module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inner-page"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (_vm.props) ? _c('div', {
    staticClass: "inner-page-wrap"
  }, [_c('Header'), (_vm.props.better_featured_image) ? _c('div', {
    style: ({
      backgroundImage: 'url(' + _vm.props.better_featured_image.source_url + ')'
    }),
    attrs: {
      "id": "inner-banner"
    }
  }, [_c('div', {
    staticClass: "slider-overlay"
  }), _c('div', {
    staticClass: "container"
  }, [(_vm.props.title.rendered) ? _c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.title.rendered)
    }
  }) : _vm._e()])]) : _vm._e(), _c('div', {
    staticClass: "amenities-page"
  }, [_c('div', {
    staticClass: "container clearfix"
  }, [(_vm.props.acf.left_content) ? _c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.left_content)
    }
  }) : _vm._e(), _c('div', {
    staticClass: "images"
  }, [(_vm.props.acf.right_image) ? _c('img', {
    attrs: {
      "src": _vm.props.acf.right_image,
      "alt": ""
    }
  }) : _vm._e()])])]), _c('Footer')], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-464593c2","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/pages/amenities/amenities.pug
// module id = 526
// module chunks = 1